let currentModal = null;
let originalUrl = "";
let originalTitle = "";
let previouslyFocusedElement = null;
let removeTimer = null;

function createCloseButton() {
    const closeButton = document.createElement("button");

    closeButton.type = "button";
    closeButton.className = "tv-modal__close";
    closeButton.setAttribute("aria-label", "Stäng");

    closeButton.innerHTML = `
        <i class="fa red fa-times-circle" aria-hidden="true"></i>
    `;

    return closeButton;
}

function createIframe(url) {
    const iframe = document.createElement("iframe");

    iframe.id = "tvFrame";
    iframe.className = "tv-modal__iframe";
    iframe.src = url;
    iframe.title = "Programinformation";
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute("frameborder", "0");

    return iframe;
}

function handleBackdropClick(event) {
    if (event.target === currentModal) {
        closeIframeModal(true);
    }
}

function handleKeydown(event) {
    if (event.key === "Escape") {
        closeIframeModal(true);
    }
}

export function openIframeModal(url) {
    if (!url) {
        return;
    }

    if (currentModal) {
        closeIframeModal(false, true);
    }

    if (removeTimer) {
        window.clearTimeout(removeTimer);
        removeTimer = null;
    }

    originalUrl = window.location.href;
    originalTitle = document.title;
    previouslyFocusedElement = document.activeElement;

    const modal = document.createElement("div");
    modal.className = "tv-modal";
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-label", "Programinformation");

    const dialog = document.createElement("div");
    dialog.className = "tv-modal__dialog";

    const closeButton = createCloseButton();
    const iframe = createIframe(url);

    dialog.appendChild(closeButton);
    dialog.appendChild(iframe);
    modal.appendChild(dialog);

    currentModal = modal;

    closeButton.addEventListener("click", function () {
        closeIframeModal(true);
    });

    modal.addEventListener("click", handleBackdropClick);
    document.addEventListener("keydown", handleKeydown);

    document.body.appendChild(modal);
    document.body.classList.add("tv-modal-open");

    window.history.pushState(
        {
            tvModal: true,
            originalUrl: originalUrl
        },
        "",
        url
    );

    requestAnimationFrame(function () {
        if (!currentModal) {
            return;
        }

        modal.classList.add("is-open");
        closeButton.focus();
    });
}

export function closeIframeModal(
    restoreHistory = true,
    removeImmediately = false
) {
    if (!currentModal) {
        return;
    }

    const modalToRemove = currentModal;
    const elementToRestoreFocusTo = previouslyFocusedElement;

    currentModal = null;
    previouslyFocusedElement = null;

    document.removeEventListener("keydown", handleKeydown);
    modalToRemove.removeEventListener("click", handleBackdropClick);

    document.body.classList.remove("tv-modal-open");

    modalToRemove.classList.remove("is-open");
    modalToRemove.classList.add("is-closing");

    const removeModal = function () {
        modalToRemove.remove();

        if (removeTimer) {
            window.clearTimeout(removeTimer);
            removeTimer = null;
        }
    };

    if (removeImmediately) {
        removeModal();
    } else {
        removeTimer = window.setTimeout(removeModal, 150);
    }

    if (restoreHistory && originalUrl) {
        window.history.pushState(
            {
                url: originalUrl
            },
            originalTitle,
            originalUrl
        );

        document.title = originalTitle;
    }

    if (
        elementToRestoreFocusTo &&
        document.contains(elementToRestoreFocusTo)
    ) {
        elementToRestoreFocusTo.focus();
    }

    originalUrl = "";
    originalTitle = "";
}

export function isIframeModalOpen() {
    return currentModal !== null;
}